
import React from "react";
import { PostSection } from "@/components/blog/PostSection";

export function EjemploRealSection() {
  return (
    <PostSection id="ejemplo-real" title="Un ejemplo real: de idea a MVP en 8 semanas">
      <p className="text-gray-300 mb-6">
        En SEOEVOLUTION usamos vibe coding activamente para construir nuestros propios productos. No como experimento, sino como parte de nuestra operativa.
      </p>

      <h3 id="proceso-semanas" className="text-xl font-semibold text-white mt-4 mb-4">
        Proceso semana a semana
      </h3>

      <div className="space-y-6 mb-6">
        <div className="bg-seo-dark/60 border-l-4 border-seo-blue rounded-r-lg p-5">
          <p className="text-white font-semibold mb-1">Semana 1-2: Definición de arquitectura</p>
          <p className="text-gray-300 text-sm">Qué hace la herramienta, qué páginas necesita, qué estructura de base de datos, qué integraciones. Todo se trabaja en texto antes de una sola línea de prompt.</p>
        </div>

        <div className="bg-seo-dark/60 border-l-4 border-seo-cyan rounded-r-lg p-5">
          <p className="text-white font-semibold mb-1">Semana 3-4: Prompt maestro</p>
          <p className="text-gray-300 text-sm">Un documento estructurado que describe la identidad visual, la arquitectura completa, los flujos de usuario, los modelos de datos y las integraciones necesarias.</p>
        </div>

        <div className="bg-seo-dark/60 border-l-4 border-seo-blue rounded-r-lg p-5">
          <p className="text-white font-semibold mb-1">Semana 5-6: Construcción iterativa</p>
          <p className="text-gray-300 text-sm">El prompt maestro se ejecuta en Lovable y se trabaja en ciclos cortos: generar, revisar, corregir, iterar. Cada iteración refina algo concreto.</p>
        </div>

        <div className="bg-seo-dark/60 border-l-4 border-seo-cyan rounded-r-lg p-5">
          <p className="text-white font-semibold mb-1">Semana 7-8: Auditoría SEO y ajuste técnico</p>
          <p className="text-gray-300 text-sm">Velocidad, estructura de URLs, metadatos, datos estructurados, Core Web Vitals. Antes del lanzamiento, la herramienta pasa los mismos criterios que aplicamos a cualquier web de cliente.</p>
        </div>
      </div>

      <p className="text-gray-300">
        El resultado es un producto funcional, con diseño coherente, backend real y posicionamiento técnico correcto, en un tiempo y a un coste que hace dos años era directamente imposible para una agencia pequeña.
      </p>
    </PostSection>
  );
}
